import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import { RatioIndicator } from '@terminal/views/theme-overview/tab-content/theme-earnings/RatioIndicator';
import type { KeyStat } from '@terminal/views/theme-overview/tab-content/theme-earnings/theme-key-stats/utils';
import clsx from 'clsx';

import styles from './IndustryThemesTable.module.scss';

interface KeyStatsCellProps {
  keyStat: KeyStat;
  primaryOnly?: boolean;
}

export const KeyStatsCell = ({ keyStat, primaryOnly }: KeyStatsCellProps) => (
  <span className={styles.keyStatsCell}>
    {!primaryOnly && keyStat.indicator && keyStat.ratio !== undefined && (
      <RatioIndicator
        className={styles.keyStatsIndicator}
        indicator={keyStat.indicator}
        ratio={keyStat.ratio}
      />
    )}
    {(keyStat.primaryText || (!primaryOnly && keyStat.secondaryText)) && (
      <span className={styles.keyStatsText}>
        {keyStat.primaryText && (
          <span
            className={clsx(styles.keyStatsPrimary, {
              [semanticColorStyles.directionPositive]:
                keyStat.primaryColor === 'bullish',
              [semanticColorStyles.directionNegative]:
                keyStat.primaryColor === 'bearish',
              [semanticColorStyles.directionNeutralSoft]:
                keyStat.primaryText === '-',
            })}
          >
            {keyStat.primaryText}
          </span>
        )}
        {!primaryOnly && keyStat.secondaryText && (
          <span className={styles.keyStatsSecondary}>
            {keyStat.secondaryText}
          </span>
        )}
      </span>
    )}
  </span>
);
